import { useId } from 'react';
import { shortId, type OperatorScope } from '../auth/operator-scope';
import { useT } from '../hooks';
import { useServices } from '../services';

/**
 * Tenant and outlet the operator acts for. A selector appears only when the token assigns
 * more than one; a single assignment is shown as the outlet name in the app bar instead,
 * so this renders nothing then.
 */
export function ScopeSelectors({ scope }: { scope: OperatorScope }) {
  const t = useT();
  const { tenantStore, outletStore } = useServices();
  const tenantSelect = useId();
  const outletSelect = useId();
  return (
    <div className="scope">
      {scope.tenantIds.length > 1 && (
        <div className="field field--inline">
          <label htmlFor={tenantSelect}>{t('operator.scope.tenant')}</label>
          <select id={tenantSelect} value={scope.tenantId} onChange={(e) => tenantStore.set(e.target.value)}>
            {scope.tenantIds.map((id) => (
              <option key={id} value={id}>
                {shortId(id)}
              </option>
            ))}
          </select>
        </div>
      )}
      {scope.outletIds.length > 1 && (
        <div className="field field--inline">
          <label htmlFor={outletSelect}>{t('operator.scope.outlet')}</label>
          <select id={outletSelect} value={scope.outletId} onChange={(e) => outletStore.set(e.target.value)}>
            {scope.outletIds.map((id) => (
              <option key={id} value={id}>
                {t('operator.scope.outletOption', { short: shortId(id) })}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
